import React from 'react';

export default function Enotas() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M18.3794 10.3073C18.3865 14.5725 18.3884 14.6097 18.5654 14.1109C19.3947 11.7736 21.0261 9.54522 23.0104 8.03941C23.8139 7.42974 25.3779 6.58832 26.3394 6.24857L27.0003 6.01501L22.6862 6.00746L18.3721 6L18.3794 10.3073Z'
        fill='#841E67'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.00489 10.257L7.00978 14.5139L7.25007 13.8833C8.57672 10.401 11.3014 7.63246 14.6806 6.3328L15.5285 6.00665L11.2642 6.00332L7 6L7.00489 10.257Z'
        fill='#E44F25'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.00309 21.7428L7.00608 25.9998L7.38154 25.0893C8.77941 21.6991 11.2175 19.2509 14.5529 17.8881L15.5285 17.4894L11.2642 17.4877L7 17.4858L7.00309 21.7428Z'
        fill='#009BA3'
      />
    </svg>
  );
}
